import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClassificacaoSkincareComponent } from './classificacao-skincare.component';
import { ClassificacaoSkincareRoutingModule } from './classificacao-skincare-routing.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule, SharedModule, ClassificacaoSkincareRoutingModule],
  declarations: [ClassificacaoSkincareComponent]
})
export class ClassificacaoSkincareModule {}
